import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import group from "../../assets/images/karimjee.png";
import spin from "../../assets/spin.svg";
import zxcvbn from "zxcvbn";
import "../../waves.css";
import postDataTrace from "../../services/postDataTrace";
import { Col, Form, Input, message, Row, Select } from "antd";
import { AuthContext } from "../../contexts/AuthContext";
import { PasswordInput } from "antd-password-input-strength";
import fetchAllSites from "../../services/fetchAllSites";
import fetchAllRoles from "../../services/fetchAllRoles";
import fetchDataTrace from "../../services/fetchDataTrace";

const { Option } = Select;

export default function Signin() {
  const { signin } = useContext(AuthContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSpinning, setSpinning] = useState(false);

  const navigate = useNavigate();

  const [code, setCode] = useState<any>("+255");

  const [roles, setRoles] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [firms, setFirms] = useState<any>([]);

  const [form] = Form.useForm();

  const startsWith = (str: any, word: any) => {
    return str.lastIndexOf(word, 0) === 0;
  };

  const handleCompanyCode = (e: any) => {
    setCode(e);
  };

  const onSubmit = async () => {
    const { firstname, lastname, email, mobile, password, role, site, firm } =
      form.getFieldsValue();

    let formated = null;

    const score = password.length === 0 ? -1 : zxcvbn(password).score;
    if (score < 3) {
      message.error("Use stronger password");
    } else {
      const trimmed = mobile.replace(/\s/g, "");
      if (trimmed.toString().length === 10) {
        let zero = startsWith(`${trimmed}`, "0");
        if (zero) {
          let num = trimmed.substring(1);
          formated = `${code}${num}`;
        }
      } else {
        if (trimmed.toString().length < 9 || trimmed.toString().length > 9) {
          message.error("Please provide a valid number");
          return;
        }
        formated = `${code}${trimmed}`;
      }
      const data = {
        firstname,
        lastname,
        email,
        mobile: formated,
        password,
        role,
        site,
        firm,
        accessLevel: 2,
        isClaimer: false,
        isMessaged: false,
      };
      const uri = "users/register/staff/self";
      const response = await postDataTrace(data, uri);
      if (response.success) {
        message.success("Registed Successfully");
        form.resetFields();
        navigate("/login");
      } else {
        message.error(response.message);
      }
    }
  };

  const handleFetchRoles = async () => {
    const response = await fetchAllRoles();
    setRoles(response?.payload);
  };

  const handleFetchFirms = async () => {
    const uri = `firms`;
    const response = await fetchDataTrace({ uri });
    setFirms(response?.payload);
  };

  const handleFetchSites = async () => {
    const response = await fetchAllSites();
    setSites(response?.payload);
  };

  const siteOptions = sites.map((site: any, index: number) => (
    <Option value={site?._id} key={index}>
      {site?.name}
    </Option>
  ));

  const roleOptions = roles.map((role: any, index: number) => (
    <Option value={role?._id} key={index}>
      {role?.name}
    </Option>
  ));

  const firmOptions = firms?.map((company: any, index: number) => (
    <Option value={company?._id} key={index}>
      {company?.name}
    </Option>
  ));

  useEffect(() => {
    handleFetchSites();
    handleFetchRoles();
    handleFetchFirms();
  }, []);

  useEffect(() => {
    if (email.trim() && password.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email, password]);

  return (
    <div className="header">
      <div className="inner-header flexo">
        <div className="max-w-2xl w-full pt-24 sm:pt-24 px-5">
          <div className="flex flex-row justify-center w-full">
            <div className="w-full sm:w-full p-4 bg-gray-100 rounded-lg">
              <div className="text-center mt-4">
                <img className="mx-auto h-16 w-auto " src={group} alt="" />
                <p>Register KJG Account</p>
              </div>
              <div className="mb-">
                <Form
                  id="Register"
                  form={form}
                  name="normal_login"
                  className="login-form"
                  onFinish={onSubmit}
                  layout="vertical"
                >
                  <Row gutter={[16, 0]}>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="firstname"
                        label={"Firstname"}
                        rules={[
                          {
                            required: true,
                            message: "Please enter Firstname",
                          },
                        ]}
                      >
                        <Input
                          placeholder="First Name"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="lastname"
                        label={"Lastname"}
                        rules={[
                          {
                            required: true,
                            message: "Please enter Lastname",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Last Name"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 0]}>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="email"
                        label={"Email"}
                        rules={[
                          {
                            required: true,
                            message: "Please enter Email",
                          },
                        ]}
                      >
                        <Input
                          type={"email"}
                          placeholder="Email"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="password"
                        label={"Password"}
                        rules={[
                          {
                            required: true,
                            message: `Please enter Password`,
                          },
                        ]}
                      >
                        <PasswordInput
                          inputProps={{
                            size: "middle",
                            placeholder: "Password",
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 0]}>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="mobile"
                        label="Mobile"
                        rules={[
                          {
                            required: true,
                            message: "Please enter mobile",
                          },
                        ]}
                      >
                        <Input
                          addonBefore={
                            <>
                              <Select
                                defaultValue={"+255"}
                                onChange={(e) => handleCompanyCode(e)}
                              >
                                <Option value="+254">🇰🇪 +254</Option>
                                <Option value="+255">🇹🇿 +255</Option>
                                <Option value="+256">🇺🇬 +256</Option>
                              </Select>
                            </>
                          }
                          style={{ width: "100%" }}
                          placeholder="Mobile"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="firm"
                        label={"Company"}
                        rules={[
                          {
                            required: true,
                            message: "Please select company",
                          },
                        ]}
                      >
                        <Select placeholder="Company">{firmOptions}</Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  {/* <Row gutter={[16, 0]}>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                      <Form.Item
                        name="firm"
                        label={"Company"}
                        rules={[
                          {
                            required: true,
                            message: "Please select company",
                          },
                        ]}
                      >
                        <Select placeholder="Company">{firmOptions}</Select>
                      </Form.Item>
                    </Col>
                  </Row> */}

                  <div className="border-t border-gray-300 mt-2 mb-4 w-full"></div>
                  <Form.Item wrapperCol={{ span: 24 }}>
                    <button
                      className="group relative w-full flex justify-center py-3 sm:py-2 px-4
                border border-transparent text-sm leading-5 font-medium
                rounded-md text-white  hover:text-blue-900
                focus:outline-none 
                focus:shadow-outline-indigo  transition
                duration-150 ease-in-out"
                      style={{ background: "#4145A8" }}
                    >
                      <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                        <svg
                          className="h-5 w-5 text-white group-hover:text-whitetransition ease-in-out duration-150"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                          />
                        </svg>
                      </span>
                      {isSpinning ? (
                        <span>
                          <img
                            src={spin}
                            alt="spin"
                            height="20px"
                            width="20px"
                          />
                        </span>
                      ) : (
                        <span className="text-white">Register</span>
                      )}
                    </button>
                  </Form.Item>
                </Form>
                <div className="border-t border-gray-300 mb-6 w-full"></div>
                <div className="flex justify-center items-center text-gray-600 text-xs">
                  <div className="">Already have an account ? </div>
                  <Link
                    to="/login"
                    className="text-xs text-center flex items-center text-karimjee hover:text-toyota ml-1"
                  >
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <svg
          className="waves"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="parallax">
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </div>
  );
}
